import React from 'react'
import injectSheet from 'react-jss'
import numeral from 'numeral'
import tippy from 'tippy.js'
import { COLORS } from 'helpers/globals'

class ModelName extends React.Component {
  componentDidMount = _ =>
    this.props.modelCount > 1 && tippy(this.refs.link, { duration: 0, theme: 'topbar' })

  render() {
    const { updateUiAction, model, modelCount, isExpansion, classes } = this.props

    return (
      <div className={classes.model}>
        <span className={classes.label}>Model</span>
        { modelCount > 1
          ? <a
              onClick={_ => updateUiAction({ modal: isExpansion ? 'ExpansionControllerModelSelector' : 'DoorControllerModelSelector' })}
              className={classes.link}
              title={`Select from ${numeral(modelCount).format('0,0')} models`}
              ref='link'
            >
              <span className={classes.modelName}>{model.text}</span>
              <span className={classes.button}>Select Model</span>
            </a>
          : <span className={classes.noSelect}>{model.text}</span>
        }
      </div>
    )
  }
}

const style = {
  model: {
    display: 'flex',
    padding: '0 .8rem',
    width: '100%'
  },
  label: {
    flex: '0 0 15%',
    color: 'black'
  },
  link: {
    display: 'flex',
    alignItems: 'center'
  },
  modelName: {
    textDecoration: 'underline'
  },
  noSelect: {
    color: 'black'
  },
  button: {
    background: COLORS.primary,
    color: 'white',
    fontSize: '1.2rem',
    height: 20,
    verticalAlign: 'middle',
    textAlign: 'center',
    lineHeight: '20px',
    borderRadius: 4,
    marginLeft: '.5rem',
    fontWeight: 'bold',
    padding: '0 .5rem'
  }
}

export default (injectSheet(style)(ModelName))



// WEBPACK FOOTER //
// ./src/components/DoorControllerDetails/modelName.js